import React, { Component, Suspense } from "react";
import Loader from "./components/utils/loader";

import Login from "./components/game/login/login";
import Game from "./components/game/game";
import Config from "./config";
import { SkeletonTheme } from "react-loading-skeleton";
import ScreenWakeLock from "./ScreenWakeLock";
import { requestFullScreen, exitFullScreen } from "./components/utils/requestFullScreen";
import rotateScreenIndicator from "./assets/images/screen.png";

import './i18N';
import "./css/app.css";

export default class Appcopy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoading: true,
            showLogin: false,
            loginResp1: "",
            loginResp2: "",
            error: true,
            isSessionActive: false,
            sid: "",
            BgOpacity: 1,
            loginBtnState: false,
            showLoader: false,
            stageProperties: {
                width: 1600,
                height: 960,
                deviceOrientation: "",
                deviceType: ""
            },
            showInstallPrompt: false,
            isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
            isMac: /Macintosh/i.test(navigator.userAgent) && !/iPhone|iPad/i.test(navigator.userAgent),
            isAndroid: /Android/i.test(navigator.userAgent),
            isWindows: /Windows/i.test(navigator.userAgent),
            instantPlayUrl: false,
            fullScreenEnabled: false,
            isThisPWA: false
        };
        this.config = new Config();
        this.handleResize = this.handleResize.bind(this);
        this.handleInstallClick = this.handleInstallClick.bind(this);
    }
    componentDidMount() {
        this.onAppMount();
        this.config.getDevice();
        this.checkForPWAInstall();
        this.checkForInstantPlay();

        const isSafari = /Safari/i.test(navigator.userAgent) && !/Chrome/i.test(navigator.userAgent);
        if (this.state.isIOS || (this.state.isMac && isSafari)) {
            this.setState({ showInstallPrompt: true });
        }

        this.handleResize();

        window.addEventListener('resize', this.handleResize);
        window.addEventListener('orientationchange', this.handleResize);
        document.addEventListener('visibilitychange', this.handleResize);

        this.setupInstallListener();

        // (Optional) Uncomment this if needed for star animations
        /*
        const numberOfStars = 40;
        const starfallContainer = document.getElementById('starfall');
        if (starfallContainer) {
            Array.from({ length: numberOfStars }).forEach(() => {
                const star = document.createElement('div');
                star.className = 'falling-star';
    
                const randomLeft = `${Math.random() * 100}vw`;
                const randomDelay = `${Math.random() * 5}s`;
                const randomDuration = `${3 + Math.random() * 2}s`;
                const randomSize = `${4 + Math.random() * 6}px`;
    
                star.style.left = randomLeft;
                star.style.animationDelay = randomDelay;
                star.style.animationDuration = randomDuration;
                star.style.width = randomSize;
                star.style.height = randomSize;
    
                starfallContainer.appendChild(star);
            });
        }
        */

        // (Optional) Uncomment if needed
        // this.getWeatherReport();
        this.checkPWA();
    }


    checkForPWAInstall = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const shouldInstall = urlParams.get('pwa-install') === 'true';
        this.setState({ PWAInstallUrl: shouldInstall });
        if (shouldInstall && 'serviceWorker' in navigator) {
            this.registerServiceWorker();
        }
    };

    checkForInstantPlay = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const checkStatus = urlParams.get('instant-play') === 'true';
        this.setState({ instantPlayUrl: checkStatus });
        this.setState({ fullScreenEnabled: checkStatus });
    };

    registerServiceWorker = () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then((registration) => {
                console.log('ServiceWorker registration successful');
            })
            .catch((err) => {
                console.log('ServiceWorker registration failed: ', err);
            });
    };

    setupInstallListener = () => {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            this.setState({
                deferredPrompt: e,
                showInstallPrompt: true
            });
        });
    };


    handleInstallClick = () => {
        if (this.state.isIOS || (this.state.isMac && /Safari/i.test(navigator.userAgent))) {
            return;
        }
        const { deferredPrompt } = this.state;
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(choiceResult => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted install');
                }
                this.setState({ deferredPrompt: null, showInstallPrompt: false });
            });
        }
    };


    checkPWA = () => {
        const standaloneMedia = window.matchMedia('(display-mode: standalone)').matches;
        const iosStandalone = window.navigator.standalone === true;

        console.log('matchMedia:', standaloneMedia);
        console.log('navigator.standalone:', iosStandalone);

        const isPWA = this.state.isIOS ? iosStandalone : this.state.isAndroid && standaloneMedia;

        this.setState({ isThisPWA: isPWA });
    };



    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('orientationchange', this.handleResize);
        document.removeEventListener('visibilitychange', this.handleResize);
    }


    // getWeatherReport() {
    //     if (navigator.geolocation) {
    //         navigator.geolocation.getCurrentPosition(position => {
    //             const lat = position.coords.latitude;
    //             const lon = position.coords.longitude;
    //             console.log(`Latitude: ${lat}, Longitude: ${lon}`);

    //             const now = new Date();
    //             const hours = now.getHours();

    //             let weather = '';
    //             if (hours >= 6 && hours <= 18) {
    //                 weather = 'Sunny or Clear Skies (Daytime)';
    //             } else {
    //                 weather = 'Cool or Cloudy (Nighttime)';
    //             }

    //             console.log(`Estimated Weather: ${weather}`);
    //         }, error => {
    //             console.log('Error getting location:', error.message);
    //         });
    //     } else {
    //         console.log('Geolocation is not supported by this browser.');
    //     }
    // };

    handleResize() {
        const getDeviceTypeAndOrientation = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            const userAgent = navigator.userAgent.toLowerCase();

            const isMobile = /mobile|iphone|ipod|android/i.test(userAgent);
            const isTablet = /tablet|ipad|android(?!.*mobile)/i.test(userAgent);
            const isDesktop = !isMobile && !isTablet;

            const orientation = width > height ? 'landscape' : 'portrait';

            if (isDesktop) {
                return { device: 'desktop', orientation: null };
            }

            if (isTablet) {
                return { device: 'tablet', orientation };
            }

            if (isMobile) {
                return { device: 'mobile', orientation };
            }

            return { device: 'unknown', orientation: null };
        };

        const deviceInfo = getDeviceTypeAndOrientation();
        // console.log(`Device: ${deviceInfo.device}, Orientation: ${deviceInfo.orientation}`);
        sessionStorage.setItem("DeviceOrientation", JSON.stringify({ device: `${deviceInfo.device}`, Orientation: `${deviceInfo.orientation}` }));
        if (
            (deviceInfo.device === "mobile" && deviceInfo.orientation === "landscape") ||
            (deviceInfo.device === "tablet" && deviceInfo.orientation === "landscape") ||
            (deviceInfo.device === "desktop")
        ) {
            if (deviceInfo.device === "mobile") {

                this.setState({
                    stageProperties: {
                        width: 800,
                        height: 480,
                        // width: 1600,
                        // height: 960,
                        deviceOrientation: deviceInfo.orientation,
                        deviceType: deviceInfo.device
                    }
                });
            } else {
                this.setState({
                    stageProperties: {
                        // width: 800,
                        // height: 480,
                        width: 1600,
                        height: 960,
                        deviceOrientation: deviceInfo.orientation,
                        deviceType: deviceInfo.device
                    }
                });

            }
        } else {
            this.setState({
                stageProperties: {
                    width: 550,
                    height: 760,
                    deviceOrientation: deviceInfo.orientation,
                    deviceType: deviceInfo.device
                }
            });
        }
    }

    onFormSubmit(from) {
        if (from === 'login_err') {
            this.setState({ showLoader: false });
        } else {
            // if (this.state.instantPlayUrl && this.state.stageProperties.deviceType === "mobile") {
            if (this.state.isIOS || this.state.isAndroid) {
                requestFullScreen();
            }
            this.setState({ loginResp1: "Please Wait...  Loggin In", loginResp2: "", BgOpacity: 0.5, loginBtnState: true, error: true, showLoader: true });
        }
    };

    logOutHandler() {
        this.setState({ showLoader: true });
        sessionStorage.clear();
        // if (this.state.instantPlayUrl && this.state.stageProperties.deviceType === "mobile") {
        if (this.state.isIOS || this.state.isAndroid) {
            exitFullScreen();
        }
        setTimeout(() => {
            this.clearLocalStorageValues();
            this.setState({ showLogin: true, showLoading: false, isSessionActive: false, sid: null, BgOpacity: 1, showLoader: false });
        }, 2000);
    };

    clearLocalStorageValues() {
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith("profileBackground_")) {
                localStorage.removeItem(key);
            }
        }

    }

    AppHandler(action) {
        if (action) {
            this.setState({ showLoader: false });
            if (action.status) {
                this.setState({ showLogin: false, showLoading: false, isSessionActive: true, sid: action.sid, loginResp1: "", loginResp2: "", loginBtnState: false, error: true });
            } else {
                this.setState({ showLogin: true, showLoading: false, loginResp1: "Oops!", loginResp2: action.description, loginBtnState: false, BgOpacity: 1, isSessionActive: false, error: false });
            }
        }
    };

    onAppMount() {
        var sessionData = JSON.parse(sessionStorage.getItem(`${window.location.hostname}_sid`));
        if (sessionData) {
            this.setState({ sid: sessionData.sid, showLogin: false, showLoading: false });
        } else {
            this.setState({ showLogin: true, showLoading: false });
        }
    };

    handleFullScreenClick = () => {
        const { instantPlayUrl, isIOS, isAndroid } = this.state;
        if (instantPlayUrl && (isIOS || isAndroid)) {
            this.setState({ fullScreenEnabled: false });
            requestFullScreen();
        }
    };

    render() {
        const { showInstallPrompt, isIOS, isMac, isAndroid, isWindows, PWAInstallUrl, instantPlayUrl, fullScreenEnabled, isThisPWA } = this.state;
        return (
            <div className={`${(this.state.stageProperties.deviceOrientation === "landscape" || this.state.stageProperties.deviceOrientation === null) ? "AppLandscapeBg" : "AppPortraitBg"} App`}>
                <ScreenWakeLock />
                {/* <div className="starfall" id="starfall"></div> */}
                {/* <div class="wrapper">
                    <div class="backdrop"></div>
                    <div class="stage_floor"></div>
                    <div class="stage_highlight"></div>
                    <div class="spotlight_swivel">
                        <div class="lamp"></div>
                    </div>
                </div> */}

                {fullScreenEnabled && (instantPlayUrl && (isIOS || isAndroid)) && (
                    // ================================ Instant Play PopUp - Start ================================
                    <div className="pwa-install-container">
                        <div className="pwa-install-popup">
                            <div className="pwa-install-content">
                                <h3>Please Enable Full Screen</h3>
                                <p className="benefit-text">Click the button below to enable full screen.</p>
                                <button style={{ width: "100%" }} className="btn_2" onClick={this.handleFullScreenClick} >
                                    <i className="bi bi-fullscreen" style={{ marginRight: "8px" }}></i>
                                    Full Screen
                                </button>
                            </div>
                        </div>
                    </div>
                    // ================================ Instant Play PopUp - End ================================
                )}


                {
                    (showInstallPrompt && PWAInstallUrl) && (
                        // ================================ PWA PopUp - Start ================================ */}
                        <div className="pwa-install-container">
                            <div className="pwa-install-popup">
                                <div className="pwa-install-content">
                                    <h3>🎮 Install Our Game App</h3>
                                    <p className="benefit-text">Get the best experience with faster loading and home screen access!</p>

                                    {(isAndroid || isWindows || (isMac && !/Safari/i.test(navigator.userAgent))) && (
                                        <button style={{ width: "100%" }}
                                            id="pwa-install-button"
                                            className="btn_2"
                                            onClick={this.handleInstallClick}
                                            aria-label="Install game application"
                                        >
                                            <span className="install-icon">⬇️</span> Install Now
                                        </button>
                                    )}

                                    <div className="platform-instructions">
                                        {isWindows && (
                                            <div className="instruction windows-instruction">
                                                <span className="icon">🖥️</span> Adds to your <strong>Start Menu</strong>
                                            </div>
                                        )}

                                        {isMac && !isIOS && !/Safari/i.test(navigator.userAgent) && (
                                            <div className="instruction mac-instruction">
                                                <span className="icon">💻</span> Adds to your <strong>Dock</strong>
                                            </div>
                                        )}

                                        {isMac && /Safari/i.test(navigator.userAgent) && (
                                            <div className="instruction mac-instruction">
                                                <ol>
                                                    <li>Click <strong>File</strong> in menu bar</li>
                                                    <li>Select <strong>"Add to Dock"</strong></li>
                                                </ol>
                                            </div>
                                        )}

                                        {isIOS && (
                                            <div className="instruction ios-instruction">
                                                <p><span className="icon">📱</span> Follow the steps below to <strong>install PWA</strong>:</p>
                                                <ol>
                                                    <li>
                                                        Tap on
                                                        <span class="icon">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                height="24"
                                                                viewBox="0 -960 960 960"
                                                                width="24"
                                                                fill="#4287f5"
                                                                aria-hidden="true"
                                                            >
                                                                <path d="M240-40q-33 0-56.5-23.5T160-120v-440q0-33 23.5-56.5T240-640h120v80H240v440h480v-440H600v-80h120q33 0 56.5 23.5T800-560v440q0 33-23.5 56.5T720-40H240Zm200-280v-447l-64 64-56-57 160-160 160 160-56 57-64-64v447h-80Z" />
                                                            </svg>
                                                        </span>
                                                        {/* in Safari */}
                                                    </li>
                                                    <li>
                                                        Select <strong>"Add to Home Screen"</strong>
                                                        <span class="icon">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                height="24"
                                                                viewBox="0 -960 960 960"
                                                                width="24"
                                                                fill="#4287f5"
                                                                aria-hidden="true"
                                                            >
                                                                <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm360-360v160h-80v-160H280v-80h160v-160h80v160h160v80H560Z" />
                                                            </svg>
                                                        </span>
                                                    </li>
                                                    <li>Enter a display name as Riverpoker and click on Add</li>
                                                </ol>
                                            </div>
                                        )}

                                        {isAndroid && (
                                            <div className="instruction android-instruction">
                                                <span className="icon">📱</span> Works offline after installation
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        // ================================ PWA PopUp - End ================================ */}
                    )
                }


                {(isThisPWA && (isIOS || isAndroid) && this.state.stageProperties.deviceOrientation !== "landscape") && (
                    <div className="screen_rotate_box">
                        <img src={rotateScreenIndicator} alt="" />
                        <p>Please rotate your phone to continue...</p>
                    </div>
                )}


                {this.state.showLoader && <Loader />}

                <Suspense fallback={<Loader />}>
                    {!this.state.showLoading && this.state.showLogin && (
                        <Login className="animateComponent" stageProperties={this.state.stageProperties} handler={this.AppHandler.bind(this)} onSubmit={this.onFormSubmit.bind(this)} loginBtnState={this.state.loginBtnState} />
                        // <Login className="animateComponent" stageProperties={this.state.stageProperties} handler={this.AppHandler.bind(this)} onSubmit={this.onFormSubmit.bind(this)} loginBtnState={this.state.loginBtnState} />
                    )}
                    {!this.state.showLoading && !this.state.showLogin &&
                        <SkeletonTheme baseColor="#313131" highlightColor="#525252">
                            <Game sid={this.state.sid} stageProperties={this.state.stageProperties} logOutHandler={this.logOutHandler.bind(this)} />
                            {/* <Game sid={this.state.sid} stageProperties={this.state.stageProperties} logOutHandler={this.logOutHandler.bind(this)} /> */}
                        </SkeletonTheme>
                    }
                </Suspense>
            </div >
        );
    }
}
